var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 3.10104C8.70147 1.37077 4.8368 1.28687 1.66699 2.12229V13.5082C3.91213 12.4573 7.95707 12.1195 10.0003 13.8733M10.0003 3.10104V13.8733M10.0003 3.10104C11.2992 1.37077 15.1639 1.28687 18.3337 2.12229V13.5082C16.0885 12.4573 12.0436 12.1195 10.0003 13.8733",
    stroke: "#FFC786",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIconHover);
export default __webpack_public_path__ + "static/media/bookIconHover.e05a03913e96286406e92d97236cff2f.svg";
export { ForwardRef as ReactComponent };